import { createFileRoute } from "@tanstack/react-router";
import Layout from "@/components/layout/Layout";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import { pageHead } from "@/lib/routeHead";

export const Route = createFileRoute("/privacy-policy")({
  component: () => (
    <Layout>
      <PrivacyPolicy />
    </Layout>
  ),
  head: () =>
    pageHead({
      title: "Privacy Policy",
      description:
        "How Rex & Sons RVs collects, uses, and protects your personal information — contact details, financing applications, trade-ins, parts orders, cookies and your privacy choices.",
      path: "/privacy-policy",
    }),
});
